import PaymentManagementProductListing from "pages/PaymentManagement/Product/Listing";
import { action_options, app_modules } from "../../helpers/apps_modules_list";
import PaymentManagementServicePage from "../../pages/PaymentManagement/Service/Listing";
import RecordPayment from "pages/PaymentManagement/RecordPayment";

const PaymentManagementRoutes: any = [

  // PRODUCT ROUTES
  {
    path: "/payment-management/product",
    name: "Payments Management Product",
    component: <PaymentManagementProductListing />,
    permissions: {
      app_name: app_modules?.payment_management?.app_name,
      module_name: app_modules?.payment_management?.modules?.product,
      action: action_options?.view,
    },
  },
  {
    path: "/payment-management/service",
    name: "Payments Management Service",
    component: <PaymentManagementServicePage />,
    permissions: {
      app_name: app_modules?.payment_management?.app_name,
      module_name: app_modules?.payment_management?.modules?.service,
      action: action_options?.view,
    },
  },
  {
    path: "/payment-management/:order_type/:payment_type/record-payment/:id",
    name: "Record Payment",
    component: <RecordPayment />,
    permissions: {
      app_name: app_modules?.payment_management?.app_name,
      module_name: app_modules?.payment_management?.modules?.service,
      action: action_options?.view,
    },
  },
];

export default PaymentManagementRoutes;
